var _a;
import { ActivitiesEntryTypeEnum } from "./interfaces";
export var ENTRY_TYPE_TO_CODE = (_a = {},
    _a[ActivitiesEntryTypeEnum.HOMEPAGE] = "0",
    _a[ActivitiesEntryTypeEnum.ACTIVITIES_XSELL] = "1",
    _a[ActivitiesEntryTypeEnum.ACTIVITIES_XSELL_CARD] = "10",
    _a[ActivitiesEntryTypeEnum.STAYS_XSELL] = "2",
    _a[ActivitiesEntryTypeEnum.STAYS_XSELL_CARD] = "11",
    _a[ActivitiesEntryTypeEnum.UPCOMING_TRIP] = "3",
    _a[ActivitiesEntryTypeEnum.RECENTLY_SEARCHED] = "4",
    _a[ActivitiesEntryTypeEnum.SIMILAR_ACTIVITIES] = "5",
    _a[ActivitiesEntryTypeEnum.COMBINED_SEARCH_DESTINATION] = "6",
    _a[ActivitiesEntryTypeEnum.COMBINED_SEARCH_CATEGORY] = "7",
    _a[ActivitiesEntryTypeEnum.COMBINED_SEARCH_ATTRACTION] = "8",
    _a[ActivitiesEntryTypeEnum.COMBINED_SEARCH_PRODUCT] = "9",
    _a[ActivitiesEntryTypeEnum.AVAILABILITY] = "12",
    _a[ActivitiesEntryTypeEnum.MYTRIPS_XSELL_FLIGHT] = "13",
    _a[ActivitiesEntryTypeEnum.MYTRIPS_XSELL_STAY] = "14",
    _a[ActivitiesEntryTypeEnum.MYTRIPS_XSELL_ACTIVITY] = "15",
    _a[ActivitiesEntryTypeEnum.MYTRIPS_XSELL] = "16",
    _a[ActivitiesEntryTypeEnum.TRAVEL_SALE_LANDING] = null,
    _a);
export var CODE_TO_ENTRY_TYPE = {
    "0": ActivitiesEntryTypeEnum.HOMEPAGE,
    "1": ActivitiesEntryTypeEnum.ACTIVITIES_XSELL,
    "2": ActivitiesEntryTypeEnum.STAYS_XSELL,
    "3": ActivitiesEntryTypeEnum.UPCOMING_TRIP,
    "4": ActivitiesEntryTypeEnum.RECENTLY_SEARCHED,
    "5": ActivitiesEntryTypeEnum.SIMILAR_ACTIVITIES,
    "6": ActivitiesEntryTypeEnum.COMBINED_SEARCH_DESTINATION,
    "7": ActivitiesEntryTypeEnum.COMBINED_SEARCH_CATEGORY,
    "8": ActivitiesEntryTypeEnum.COMBINED_SEARCH_ATTRACTION,
    "9": ActivitiesEntryTypeEnum.COMBINED_SEARCH_PRODUCT,
    "10": ActivitiesEntryTypeEnum.ACTIVITIES_XSELL_CARD,
    "11": ActivitiesEntryTypeEnum.STAYS_XSELL_CARD,
    "12": ActivitiesEntryTypeEnum.AVAILABILITY,
    "13": ActivitiesEntryTypeEnum.MYTRIPS_XSELL_FLIGHT,
    "14": ActivitiesEntryTypeEnum.MYTRIPS_XSELL_STAY,
    "15": ActivitiesEntryTypeEnum.MYTRIPS_XSELL_ACTIVITY,
    "16": ActivitiesEntryTypeEnum.MYTRIPS_XSELL,
};
//# sourceMappingURL=entryTypeCodeMap.js.map